import AxiosClient from "../AxiosClient";

// 市況価格表　情報登録
export const postReadAPI = (params) => {
  const url = "/api/marketPriceSetting/read";
  return AxiosClient.post(url, params);
};

// 市況価格表　情報登録
export const postRegisterAPI = (params) => {
  const url = "/api/marketPriceSetting/register";
  return AxiosClient.post(url, params);
};

// 市況価格表　情報更新
export const postUpdateAPI = (params) => {
  const url = "/api/marketPriceSetting/update";
  return AxiosClient.post(url, params);
};


